import { render, staticRenderFns } from "./AssessmentScorecard.vue?vue&type=template&id=62fb8402&scoped=true&"
import script from "./AssessmentScorecard.vue?vue&type=script&lang=js&"
export * from "./AssessmentScorecard.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentScorecard.vue?vue&type=style&index=0&id=62fb8402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fb8402",
  null
  
)

export default component.exports